import React from 'react'

import { useActionless, useAppSelector } from 'app-redux/hooks'
import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'

import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'
import TabContainer from 'components/elements/TabButtons'
import DeckPriceBreakdown from 'components/deckPage/modals/PricingModals/DeckPriceBreakdown'
import OptimizeCards from 'components/deckPage/modals/PricingModals/OptimizeCards'
import BuyBulkModalBody from 'components/deckPage/modals/BuyBulk/buyBulkForm'

import styles from './pricingModals.module.scss'

type Props = {}

type tabs = 'buy' | 'stats' | 'optimize'

const PricingModals = ({}: Props) => {
  const cardMap = useAppSelector(state => state.deck.cardMap)
  const buyBulk = useAppSelector(state => state.active.modals.bulkBuy)
  const pricingDetails = useAppSelector(state => state.active.modals.pricingDetails)
  const optimizeCards = useAppSelector(state => state.active.optimizeCardOverlay)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const open = buyBulk || pricingDetails || optimizeCards

  const handleTabChange = (newTab: tabs) => {
    if (newTab === 'buy') {
      setActiveState({ modals: { bulkBuy: true }, optimizeCardOverlay: false })
    }

    if (newTab === 'stats') {
      setActiveState({
        modals: { pricingDetails: true },
        optimizeCardOverlay: false,
      })
    }

    if (newTab === 'optimize') {
      const multiSelectedIds = Object.keys(cardMap).reduce((a, id) => ({ ...a, [id]: true }), {})
      setActiveState({
        multiSelectedIds,
        modals: {},
        optimizeCardOverlay: true,
      })
    }
  }

  return (
    <GlobalOverlayStack
      open={open}
      onClose={() =>
        setActiveState({
          modals: {},
          optimizeCardOverlay: false,
          modalActive: false,
        })
      }
      className={styles.container}>
      <TabContainer
        className={styles.tabs}
        optionsClassName={styles.tabButton}
        options={[
          {
            icon: 'shopping cart',
            label: 'Buy / sell cards',
            onClick: () => handleTabChange('buy'),
            selected: buyBulk,
          },
          {
            icon: 'chart bar',
            label: 'Price breakdown',
            onClick: () => handleTabChange('stats'),
            selected: pricingDetails,
          },
          {
            icon: 'money bill alternate outline',
            label: 'Optimize deck',
            onClick: () => handleTabChange('optimize'),
            selected: optimizeCards,
          },
        ]}
      />
      <div className={styles.content}>
        {pricingDetails && <DeckPriceBreakdown />}
        {optimizeCards && <OptimizeCards onClose={() => setActiveState({ optimizeCardOverlay: false })} />}
        {buyBulk && <BuyBulkModalBody className={styles.bulkBuy} hideHeader />}
      </div>
    </GlobalOverlayStack>
  )
}

export default PricingModals
